var map = {
	"./learning/learning.module": [
		"./src/app/learning/learning.module.ts",
		"default~learning-learning-module~payments-payments-module~pros-pros-module",
		"learning-learning-module"
	],
	"./payments/payments.module": [
		"./src/app/payments/payments.module.ts",
		"default~learning-learning-module~payments-payments-module~pros-pros-module",
		"payments-payments-module"
	],
	"./players/players.module": [
		"./src/app/players/players.module.ts",
		"players-players-module"
	],
	"./pros/pros.module": [
		"./src/app/pros/pros.module.ts",
		"default~learning-learning-module~payments-payments-module~pros-pros-module",
		"pros-pros-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;